import { Box, CircularProgress, Divider, Paper } from "@mui/material";
import { skipToken } from "@reduxjs/toolkit/query";
import { FC, useEffect, useState } from "react";
import { generatePath, useParams } from "react-router-dom";
import { useGetPartnerQuery } from "src/shared/api/partner";
import { routes } from "src/shared/constants/routes.constants";
import { useBreadcrumbs } from "src/shared/providers/BreadcrumbsProvider";
import { EditPartner } from "./EditPartner";
import { Partner1CStatusAlert } from "./Partner1CStatusAlert";
import { Addresses } from "./partnerPage/Addresses";
import { ContactPersons } from "./partnerPage/ContactPersons";
import { GeneralInfo } from "./partnerPage/GeneralInfo";

export const Partner: FC = () => {
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const { setBreadcrumbs } = useBreadcrumbs();
  const { partner_id: partnerId } = useParams();

  const {
    data: partner,
    isLoading,
    isFetching,
  } = useGetPartnerQuery(partnerId || skipToken);
  const { addresses, contact_persons } = partner || {};

  useEffect(() => {
    if (!partner) return;

    setBreadcrumbs([
      { label: "Партнеры", path: routes.partners },
      {
        label: partner?.name || "",
        path: generatePath(routes.partnerItem, { partner_id: partnerId }),
      },
    ]);

    return () => setBreadcrumbs([]);
  }, [partnerId, partner, setBreadcrumbs, partner?.name]);

  if (isLoading || isFetching) {
    return (
      <Box
        sx={{
          minHeight: 200,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  if (!partner) return null;

  return (
    <>
      <Partner1CStatusAlert integration_1c={partner.integration_1c} />
      {partner && (
        <Box>
          <Paper
            sx={{
              padding: "1.875rem",
            }}
          >
            <GeneralInfo
              handleOpenEditModal={setIsEditModalOpen}
              partner={partner}
            />
          </Paper>
          <Paper
            sx={{
              padding: "1.875rem",
              marginTop: "1.25rem",
            }}
          >
            {contact_persons && (
              <>
                <Box>
                  <ContactPersons contactPersons={contact_persons} />
                </Box>
              </>
            )}
            {addresses && (
              <>
                <Divider sx={{ marginBottom: "1.25rem" }} />
                <Box>
                  <Addresses
                    partner={partner}
                    addresses={addresses}
                    registrationCountryId={partner.registration_country.id}
                  />
                </Box>
              </>
            )}
          </Paper>
        </Box>
      )}
      {isEditModalOpen && (
        <EditPartner onClose={() => setIsEditModalOpen(false)} />
      )}
    </>
  );
};
